import Model from './Model'

export default class User extends Model {
    static async all() {
        const {data} = await Http.get(route('api.v1.users.index'))
        return this.make(data.data)
    }

    toDropdown() {
        return {label: this.name, value: this.id}
    }

    static async search(query) {
        const params = {query}
        const {data} = await Http.get(route('api.v1.users.index'), {params})
        return this.make(data)
    }

    static async find(id) {
        const {data} = await Http.get(route('api.v1.users.show', id))
        return this.make(data.data)
    }
}
